import i18n from 'i18next'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import cs from './translations/cs.json'
import en from './translations/en.json'
import esMx from './translations/es-MX.json'
import ro from './translations/ro.json'
import sk from './translations/sk.json'

const resources = {
  en: {
    translation: en
  },
  es_mx: {
    translation: esMx
  },
  sk: {
    translation: sk
  },
  ro: {
    translation: ro
  },
  cs: {
    translation: cs
  }
}

i18n
  .use(initReactI18next)
  .use(I18nextBrowserLanguageDetector)
  .init({
    resources,
    fallbackLng: 'en',
    detection: {
      order: ['querystring', 'navigator'],
      lookupQuerystring: 'language'
    }
  })

export default i18n
